const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

const getWarrantyDaysRemaining = ({ end, now }: { end: Date; now: Date }): number =>
    Math.ceil((new Date(end).getTime() - now.getTime()) / MILLISECONDS_PER_DAY);

export default getWarrantyDaysRemaining;
